// extracted by mini-css-extract-plugin
module.exports = {"eventsGrid":"agenda_eventsGrid__VIE3R"};